export const shortenText = (
  text: string | null | undefined,
  maxLength?: number,
  removeEmptyLines?: boolean,
  toLastPunctuation?: boolean
) => {
  if (!text) {
    return ''
  }

  let shortenedText = text

  if (removeEmptyLines) {
    shortenedText = shortenedText.replace(/^\s*\n/gm, '')
  }

  if (maxLength && shortenedText.length > maxLength) {
    shortenedText = shortenedText.substring(0, maxLength - 1)
  }

  if (toLastPunctuation) {
    const punctuations = ['.', '?', '!']
    const lastPunctiation = Math.max(
      ...punctuations.map(character => shortenedText.lastIndexOf(character))
    )

    if (lastPunctiation > 0) {
      return shortenedText.substring(0, lastPunctiation + 1)
    }
  }

  return shortenedText
}
